module.exports = __webpack_public_path__ + "static/media/A2_04.18e23085.png";